import Vue from "vue";
import Router from "vue-router";
import auth from "./modules/auth";
import dashboard from "./modules/dashboard";
import statics from "./modules/statics";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [...auth, ...dashboard, ...statics]
});



// WEBPACK FOOTER //
// ./src/router/index.js